export const translatableFields: Record<string, string[]> = {
  'locations:location': ['name', 'gateInstructions'],
}

export default translatableFields
